import React from "react";
import {
  Plus,
  Pencil,
  Trash2,
  Check,
  Upload,
  User,
  Lock,
  MinusCircle,
  Home,
  PanelLeftClose,
  PanelLeftOpen,
  Tag,
  IdCard,
  Store,
  Package,
  ShoppingCart,
  ArrowLeftRight,
  CreditCard,
  CircleHelp,
  Headphones,
  Settings,
  ImagePlus,
  CircleCheck,
  Clock,
  MapPin,
  Eye,
  Search,
  MessageSquare,
  ShoppingBag,
  Mail,
  Phone,
  BadgeCheck,
  AlertTriangle,
  DollarSign,
  Calendar,
  ClipboardList,
  Printer,
  MoreHorizontal,
  Info,
  Truck,
  PlusSquare,
  Wallet,
  Settings2,
} from "lucide-react";

const mk =
  (Icon) =>
  ({ className, style, ...p }) =>
    (
      <Icon
        className={className}
        style={style}
        size={p.size ?? 18}
        strokeWidth={2}
        {...p}
      />
    );

/** Ant Design icon names → Lucide (admin migration) */
export const PlusOutlined = mk(Plus);
export const EditOutlined = mk(Pencil);
export const DeleteOutlined = mk(Trash2);
export const CheckOutlined = mk(Check);
export const UploadOutlined = mk(Upload);
export const UserOutlined = mk(User);
export const LockOutlined = mk(Lock);
export const MinusCircleOutlined = mk(MinusCircle);
export const MenuFoldOutlined = mk(PanelLeftClose);
export const MenuUnfoldOutlined = mk(PanelLeftOpen);
export const HomeOutlined = mk(Home);
/** antd used UserOutlined for "Users" menu */
export const AppstoreAddOutlined = mk(ImagePlus);
export const TagOutlined = mk(Tag);
export const ProfileOutlined = mk(IdCard);
export const ShopOutlined = mk(Store);
export const AppstoreOutlined = mk(Package);
export const ShoppingCartOutlined = mk(ShoppingCart);
export const TransactionOutlined = mk(ArrowLeftRight);
export const CreditCardOutlined = mk(CreditCard);
export const QuestionCircleOutlined = mk(CircleHelp);
export const CustomerServiceOutlined = mk(Headphones);
export const SettingOutlined = mk(Settings);
export const EyeOutlined = mk(Eye);
export const EyeFilled = mk(Eye);
export const PrinterFilled = mk(Printer);
export const EllipsisOutlined = mk(MoreHorizontal);
export const InfoCircleOutlined = mk(Info);
export const SearchOutlined = mk(Search);
export const CheckCircleOutlined = mk(CircleCheck);
export const ClockCircleOutlined = mk(Clock);
export const EnvironmentOutlined = mk(MapPin);
export const MessageOutlined = mk(MessageSquare);
export const ShoppingOutlined = mk(ShoppingBag);
export const MailOutlined = mk(Mail);
export const PhoneOutlined = mk(Phone);
export const VerifiedOutlined = mk(BadgeCheck);
export const WarningOutlined = mk(AlertTriangle);
export const DollarOutlined = mk(DollarSign);
export const CalendarOutlined = mk(Calendar);
export const CarryOutOutlined = mk(ClipboardList);
export const TruckOutlined = mk(Truck);
export const PlusSquareOutlined = mk(PlusSquare);
export const WalletOutlined = mk(Wallet);
export const Settings2Outlined = mk(Settings2);
